@if(!isDialog) {
<t4-header icon="glyphicon-stats" title="{{'T4.Campaigns' |translate : 'Campaign' }}">
  @if(campaign?.IsTemplate && campaign?.GenerationPattern == 0) {
  <button mat-button color="primary" type="button" (click)="generateVouchers()" style="margin-left: 10px;"><mat-icon>confirmation_number</mat-icon>&nbsp;{{ 'T4.Campaign.createCampaign.lblcreatevouchers' | translate : 'Create Vouchers'}}</button>
  }
</t4-header>
}

@if(campaign){
<ng-container>
  <t4-container>
    @if(!campaign.IsTemplate){
    <h1>{{campaign.DiscountCode}}<mat-icon style="margin-bottom:5px;" class="campaignName">campaign</mat-icon></h1>
    }
    <h4>{{campaign.Comment}}</h4>
  </t4-container>
  <mat-tab-group>
    @if(false){
    <mat-tab label="{{'T4.Campaigns.Campaign.tblusage' | translate : 'Usage' }}">

      <t4-dashboard>
        <div class="col-md-6">
          <t4-chart [diagramIds]="[['BO_Turnover', 'y-axis-0'], ['BO_CurrentPrognosis', 'y-axis-0']]" title="{{'T4.Campaign.Dashboard.quantity' | translate : 'Quantity' }}" type="line" [fromDate]="fromDate" [toDate]="toDate" unit="week"></t4-chart>
        </div>
        <div class="col-md-6">
          <t4-chart [diagramIds]="[['BO_Turnover', 'y-axis-0'], ['BO_CurrentPrognosis', 'y-axis-0']]" title="{{'T4.Campaiga.Dashboard.amount' | translate : 'Amount' }}" type="line" [fromDate]="fromDate" [toDate]="toDate" unit="week"></t4-chart>
        </div>
        <div class="col-md-2">
          <t4-kpi kpiId="BO_AvgPrice" title="{{'Turbo.Bookings.Dashboard.AveragePriceVAT' | translate : 'Average price incl. VAT' }}" type="currency" [fromDate]="fromDate" [toDate]="toDate"></t4-kpi>
        </div>
      </t4-dashboard>
    </mat-tab>
    }

    <mat-tab label="{{'T4.Campaigns.tblSettings' | translate : 'Settings' }}">
      <t4-container title="{{'T4.Campaigns.Campaign.valid' |translate : 'Valid' }}">

        @if(!campaign.IsTemplate){
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.validfrom' |translate : 'Valid From' }}<mat-icon class="campaigninfoicon" matSuffix matTooltip="{{ 'T4.Campaigns.Campaign.tipstartfrom2' | translate : 'Campaign is valid from this date' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input type="text" [formControl]="inputValidFrom" matInput [(ngModel)]="campaign.ValidFrom" value="{{campaign.ValidFrom | date : 'yyyy-MM-dd'}}" [matDatepicker]="fromDatepicker" />
              <mat-error>{{ 'T4.Campaigns.CampaignList.errInvalidFromdate' | translate : 'From date is invalid' }}</mat-error>
              <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #fromDatepicker></mat-datepicker>
            </mat-form-field>

          </div>
        </div>
        }

        @if(!campaign.IsTemplate){
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.validthrough' |translate : 'Valid To' }}<mat-icon class="campaigninfoicon" matSuffix matTooltip="{{ 'T4.Campaigns.Campaign.tipvalidto' | translate : 'Campaign is valid to this date' }}">help</mat-icon></div>
          <div class="col-9">

            <mat-form-field appearance="outline">
              <input type="text" matInput [formControl]="inputValidThrough" [(ngModel)]="campaign.ValidThrough" value="{{campaign.ValidThrough | date : 'yyyy-MM-dd'}}" [matDatepicker]="toDatepicker" />
              <mat-error>{{ 'T4.Campaigns.CampaignList.errValidTroughdate' | translate : 'Trough date is invalid' }}</mat-error>
              <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #toDatepicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        }

        @if(campaign.IsTemplate){
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.month' |translate : 'Valid Months' }}<mat-icon class="campaigninfoicon" matSuffix matTooltip="{{ 'T4.Campaigns.Campaign.tipvalidmonths' | translate : 'Campaign is valid number of months' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input [formControl]="inputMonths" placeholder="{{ 'T4.Campaigns.CampaignList.validmonths2' | translate : 'Valid Months' }}" type="text" matInput [(ngModel)]="ValidMonths" />
              <mat-error>{{ 'T4.Campaigns.CampaignList.errValidTroughmonthsNotZero2' | translate : 'Trough months is invalid. Only numbers and bigger then 0' }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        }

        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblterms' |translate : 'Terms' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipTerms2' | translate : 'The conditions for when this discount should be valid. True means that there are no more conditions than the validity period.' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input type="text" matInput [disabled]="!campaign.CanEdit" [(ngModel)]="campaign.Condition" value="{{campaign.Condition}}" />
            </mat-form-field>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lbltermsText' |translate : 'Terms Text' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipReadableTerms' | translate : 'A short description of the terms for this discount. Should inform the customer using as few words as possible.' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input type="text" [disabled]="!campaign.CanEdit" matInput [(ngModel)]="campaign.ConditionText" />
            </mat-form-field>
          </div>
        </div>

        <div class="row settingRow">
          <div class="col-3 infocheckbox" style="text-align:right;">{{'T4.Campaigns.Campaign.multipleUses' |translate : 'Possible to use more then once' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipmultipleUse2' | translate : 'Possible that the discount be usable more than once?' }}">help</mat-icon></div>
          <div class="col-9 " style="margin-top:3px;">
            <mat-checkbox class="campaigninfoicon" style="margin-left:2px;" [disabled]="!campaign.CanEdit" [(ngModel)]="campaign.MultipleUse"></mat-checkbox>
          </div>
        </div>

        @if(campaign.MultipleUse){
        <div class="row settingRow" style="margin-bottom: 10px;">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblMaxiumNumberOfUses' |translate : 'Maximum number of uses' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipmaxuse2' | translate : 'The maximum number of times this code may be used. (0 means there are no upper limit)' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input type="text" [formControl]="inputMaxUse" matInput [(ngModel)]="campaign.MaxUseCount" />
              <mat-error>{{ 'T4.Campaigns.CampaignList.errMaxUse' | translate : 'Max user have to be zero or bigger' }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        }

      </t4-container>

      <!-- Reason -->
      <t4-container title="{{'T4.Campaigns.Campaign.lblreason' |translate : 'Reason' }}">
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblreason' |translate : 'Reason' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipreasoncode' | translate : 'The reason for the discount' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              @if(campaign) {
              <mat-select [(ngModel)]="campaign.ReasonId" [disabled]="!campaign.CanEdit">
                @for(r of Reasons; track r.Id){
                <mat-option [value]="r.Id">{{r.Reason}}</mat-option>
                }
              </mat-select>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblcomment' |translate : 'Comment' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipDescriptionHint' | translate : 'A description of the discount ' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input type="text" [disabled]="!campaign.CanEdit" matInput [(ngModel)]="campaign.Comment" value="{{campaign.Comment}}" />
            </mat-form-field>
          </div>
        </div>
        <div class="row settingRow" style="margin-bottom: 10px;">
          <div class="col-3 inforow" style="text-align:right;">{{'T4.Campaigns.Campaign.lblisCommentPublic' |translate : 'Comment shows for customer' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipIsCommentPublic' | translate : 'If the comment should be shown for the end customer.' }}">help</mat-icon></div>
          <div class="col-9 bold">
            <mat-checkbox class="campaigninfoicon" style="margin-left:2px; margin-top:20px;" [disabled]="!campaign.CanEdit" [(ngModel)]="campaign.CommentIsPublic"></mat-checkbox>
          </div>
        </div>
      </t4-container>

      @if(campaign.IsInviteFriendsCampaign){
      <t4-container title="{{'T4.Campaigns.Campaign.detailsTitle' |translate : 'Details' }}">
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblTitle' |translate : 'Title' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipTitleHint' | translate : 'A title for the invite friends campaign.' }}">help</mat-icon></div>
          <div class="col-9">
            <t4-translation-editor [translationKey]="'T4.Campaign.' + campaign.DiscountCode + '.Title'" [canEditTranslation]="campaign.CanEdit"></t4-translation-editor>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblAppTitle' |translate : 'App title' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipAppTitleHint' | translate : 'An app title for the invite friends campaign.' }}">help</mat-icon></div>
          <div class="col-9">
            <t4-translation-editor [translationKey]="'T4.Campaign.' + campaign.DiscountCode + '.AppMessageTitle'" [canEditTranslation]="campaign.CanEdit"></t4-translation-editor>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblAppDescription' |translate : 'App description' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipAppDescriptionHint' | translate : 'An app description for the invite friends campaign.' }}">help</mat-icon></div>
          <div class="col-9">
            <t4-translation-editor [translationKey]="'T4.Campaign.' + campaign.DiscountCode + '.AppMessageDescription'" [canEditTranslation]="campaign.CanEdit"></t4-translation-editor>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblAppMenuTitle' |translate : 'App menu title' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipAppMenuTitleHint' | translate : 'An app menu title for the invite friends campaign.' }}">help</mat-icon></div>
          <div class="col-9">
            <t4-translation-editor [translationKey]="'T4.Campaign.' + campaign.DiscountCode + '.AppMenuMessageTitle'" [canEditTranslation]="campaign.CanEdit"></t4-translation-editor>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblAppMenuDescription' |translate : 'App menu description' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipAppMenuDescriptionHint' | translate : 'An app menu description for the invite friends campaign.' }}">help</mat-icon></div>
          <div class="col-9">
            <t4-translation-editor [translationKey]="'T4.Campaign.' + campaign.DiscountCode + '.AppMenuMessageDescription'" [canEditTranslation]="campaign.CanEdit"></t4-translation-editor>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblMessageHeader' |translate : 'Message title' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipMessageHeaderHint' | translate : 'The message title for the invite friends campaign.' }}">help</mat-icon></div>
          <div class="col-9">
            <t4-translation-editor [translationKey]="'T4.Campaign.' + campaign.DiscountCode + '.MessageContentHeader'" [canEditTranslation]="campaign.CanEdit"></t4-translation-editor>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblMessageContent' |translate : 'Message' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipMessageContentHint' | translate : 'The message for the invite friends campaign.' }}">help</mat-icon></div>
          <div class="col-9">
            <t4-translation-editor [translationKey]="'T4.Campaign.' + campaign.DiscountCode + '.MessageContent'" [canEditTranslation]="campaign.CanEdit"></t4-translation-editor>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 inforow">{{'T4.Campaigns.Campaign.lblCampaignTerms' |translate : 'Campaign terms' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipCampaignTermsHint' | translate : 'The terms and conditions for the invite friends campaign.' }}">help</mat-icon></div>
          <div class="col-9">
            <t4-translation-editor [translationKey]="'T4.Campaign.' + campaign.DiscountCode + '.CampaignTerms'" [canEditTranslation]="campaign.CanEdit"></t4-translation-editor>
          </div>
        </div>
        <div class="row settingRow">
          <div class="col-3 infocheckbox" style="text-align:right;">{{'T4.Campaigns.Campaign.NoCompetitionCampaign' |translate : 'No competition campaign' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipNoCompetitionCampaign' | translate : 'This is a no competition campaign for invite friends' }}">help</mat-icon></div>
          <div class="col-9 " style="margin-top:3px;">
            <mat-checkbox class="campaigninfoicon" style="margin-left:2px;" [disabled]="!campaign.CanEdit" [(ngModel)]="campaign.NoCompetitionCampaign"></mat-checkbox>
          </div>
        </div>
      </t4-container>
      }
      <!-- Value -->
      <t4-container title="{{'T4.Campaigns.Campaign.valuetitle' |translate : 'Value' }}">
        <div class="row settingRow">
          <div class="col-3" style="text-align:right; top:20px;"></div>
          <div class="col-9">
            <mat-radio-group [(ngModel)]="campaign.ValueType">
              <mat-radio-button [value]="0" [disabled]="!campaign.CanEdit" #rdbPercent style="margin-right: 15px;">{{'T4.Campaigns.createCampaign.lblpercent' |translate : 'Percent' }}</mat-radio-button>
              <mat-radio-button [value]="1" [disabled]="!campaign.CanEdit" #rdbValue style="margin-right: 15px;">{{'T4.Campaigns.createCampaign.lblamount' |translate : 'Amount' }}</mat-radio-button>
              <mat-radio-button [value]="2" [disabled]="!campaign.CanEdit" #rdbTime>{{'T4.Campaigns.createCampaign.lblHours' |translate : 'Hours' }}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        @if(rdbValue.checked) {
        <div class="row settingRow">
          <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblvalue' |translate : 'Value' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipvalue2' | translate : 'The monetary value of this discount' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input [disabled]="!campaign.CanEdit" type="text" [formControl]="amountValue" #amount matInput [(ngModel)]="campaign.Value" value="" />
              <mat-error>{{ 'T4.Campaigns.CampaignList.errgreaterzeroexpression' | translate : 'Value must be only numbers and greater then 0' }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        }
        @if(rdbPercent.checked) {
        <div class="row settingRow">
          <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblpercent' |translate : 'Percent' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tippercent2' | translate : 'The percentual value of this discount' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input [disabled]="!campaign.CanEdit" type="text" [formControl]="procentValue" [(ngModel)]="campaign.Value" #percent matInput value="" />
              <mat-error>{{ 'T4.Campaigns.CampaignList.errercentageexpression' | translate : 'Percentage can only contain numbers and be between 1 and 100' }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        }
        @if(rdbTime.checked) {
        <div class="row settingRow">
          <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblTime' |translate : 'Hours' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipHours' | translate : 'The number of hours to discount' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input [disabled]="!campaign.CanEdit" type="text" [formControl]="timeValue" [(ngModel)]="campaign.Value" #txtTime matInput value="" />
              <mat-error>{{ 'T4.Campaigns.CampaignList.errgreaterzeroexpression' | translate : 'Value must be only numbers and greater then 0' }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        }
      </t4-container>

      <!-- Other -->
      <t4-container title="{{'T4.Campaigns.Campaign.lblMiscellaneous' |translate : 'Miscellaneous' }}">
        <div class="row settingRow" style="margin-bottom: 10px;">
          <div class="col-3 infocheckbox" style="text-align:right;">{{'T4.Campaigns.Campaign.requireCode' |translate : 'Require code' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tiprequercode2' | translate : 'Does the user have to explicitly enter this code for it to be valid? Otherwise it will be automatically applied if the booking matches the terms.' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-checkbox style="margin-left:2px;" [disabled]="!campaign.CanEdit" [(ngModel)]="campaign.RequireCode"></mat-checkbox>
          </div>
        </div>
        <div class="row settingRow" style="margin-bottom: 10px;">
          <div class="col-3 infocheckbox" style="text-align:right;">{{'T4.Campaigns.Campaign.lblcanBeUsedWithOthers' |translate : 'Can be used with other discounts' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipisstackable2' | translate : 'Can this discount be used together with other discounts' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-checkbox class="campaigninfoicon" style="margin-left:2px;" [disabled]="!campaign.CanEdit" [(ngModel)]="campaign.IsStackable"></mat-checkbox>
          </div>
        </div>
        @if(campaign.ValueType === timeType) {
        <div class="row settingRow" style="margin-bottom: 10px;">
          <div class="col-3 infocheckbox" style="text-align:right;">{{'T4.Campaigns.Campaign.ApplyDiscountBookingToo' |translate : 'Apply Discount to Booking Fee' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipApplyDiscountBookingFee' | translate : 'Enable this option if the discount should apply to the booking fee' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-checkbox class="campaigninfoicon" style="margin-left:2px;" [disabled]="!campaign.CanEdit" [(ngModel)]="campaign.AllowDiscountOnBookingFee"></mat-checkbox>
          </div>
        </div>
        }
        <div class="row settingRow">
          <div class="col-3 inforow" style="text-align:right; top:20px;">{{'T4.Campaigns.Campaign.lblpriorty' |translate : 'Priorty' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.TipPriorityDescription' | translate : 'In which order should this discount be applied. Lower numbers are prioritized.' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input type="text" matInput [formControl]="priority" [(ngModel)]="campaign.Priority" value="{{campaign.Priority}}" />
              <mat-error>{{ 'T4.Campaigns.CampaignList.errzeroorbigger' | translate : 'Value have be 0 or bigger' }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        @if(campaign.IsTemplate && !campaign.MultipleUse){
        <div class="row settingRow" style="margin-bottom: 21px;">
          <div class="col-3 inforow" style="text-align:right; margin-top:10px;">{{'T4.Campaigns.Campaign.lblGenerationPattern' |translate : 'Generation Pattern' }}<mat-icon matSuffix class="campaigninfoicon" matTooltip="{{ 'T4.Campaigns.Campaign.tipgenerationpattern?' | translate : 'How should the discounts be generated?' }}">help</mat-icon></div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              @if(campaign){
              <mat-select [disabled]="!campaign.CanEdit" [(ngModel)]="campaign.GenerationPattern">
                <mat-option [value]="0">{{'T4.Campaigns.createCampaign.lblmanually' |translate : 'Manually' }}</mat-option>
                <mat-option [value]="1">{{'T4.Campaigns.createCampaign.lblweekly' |translate : 'Weekly' }}</mat-option>
                <mat-option [value]="2">{{'T4.Campaigns.createCampaign.lblmonthly' |translate : 'Monthly' }}</mat-option>
                <mat-option [value]="3">{{'T4.Campaigns.createCampaign.lblyearly' |translate : 'Yearly' }}</mat-option>
              </mat-select>
              }
            </mat-form-field>
          </div>
        </div>
        }
      </t4-container>

      <br />
      @if(campaign.CanEdit){
      <div>
        <button [disabled]="
                      (inputValidThrough.errors &&  !campaign.IsTemplate) ||
                      (ValidMonths.errors && campaign.IsTemplate) ||
                      ( amountValue.errors && rdbValue.checked) ||
                      ( procentValue.errors && rdbPercent.checked) ||
                      priority.errors"
                mat-raised-button color="primary" matTooltip="{{ 'T4.Campaigns.Campaign.savechangesbutton' | translate : 'Save changes'}}" type="button" (click)="UpdateCampaign()" style="margin:5px; color: white; float: left;" class="btn btn-default">
          <mat-icon>assignment_turned_in</mat-icon>&nbsp;{{ 'T4.Campaign.createCampaign.lblsave' | translate : 'Save'}}
        </button>
      </div>
      }
    </mat-tab>

    <!-- Vouchers  -->
    @if(!isDialog && campaign?.IsTemplate){
    <mat-tab label="{{'T4.Campaigns.Campaign.tabgeneratevouchers' | translate : 'Vouchers' }}">
      <t4-container>
        <t4-data-table #tblTemplateList [allowFilter]="true" (itemClicked)="showCamp($event)" [rawData]="TemplateList" headline="{{'T4.Campaigns.campaigns.lbltable' | translate : 'Campaigns' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false" [filterFields]="['DiscountCode']">
          <ng-container matColumnDef="campaigncode">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{'T4.Campaigns.Campaign.lblvouchercode' |translate : 'Voucher code' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">
              @if(row.DiscountCode){
              <b>{{ row.DiscountCode }}</b>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="validthrough">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Campaigns.Campaign.lblvalid' |translate : 'Valid' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.ValidFrom | date : 'yyyy-MM-dd'}} <mat-icon>horizontal_rule</mat-icon> {{ row.ValidThrough | date : 'yyyy-MM-dd'}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="multipleuse">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:30px;">{{'T4.Campaigns.Campaign.lblmultipleuse' |translate : 'Multipleuse' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:30px;">
              @if(row.MultipleUse == 0){
              <mat-icon style="color: black">radio_button_unchecked</mat-icon>
              }
              @else if(row.MultipleUse == 1) {
              <mat-icon style="color: black">task_alt</mat-icon>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="requirecode">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width:30px;">{{'T4.Campaigns.Campaign.lblrequiresCode' |translate : 'Requires Code' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width:30px;">
              @if(row.RequireCode == 0){
              <mat-icon>radio_button_unchecked</mat-icon>
              }
              @else if(row.RequireCode == 1) {
              <mat-icon>task_alt</mat-icon>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="discountvalue">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Campaigns.Campaign.lbldiscountvalue' |translate : 'discountvalue' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">
              @if(row.ValueType == 1){
              <ng-container> {{ row.Value | currency }}</ng-container>
              }
              @else if(row.ValueType == 0) {
              <ng-container> {{ row.Value/100.00 | percent}}</ng-container>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="usagecount">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Campaigns.Campaign.lblusedcampaign' |translate : 'Used' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.UsageCount}}/{{ row.MaxUseCount}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="comment">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:170px;">{{'T4.Campaigns.Campaign.lblComment' |translate : 'Comment' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:170px;">{{ row.Comment}}</mat-cell>
          </ng-container>
        </t4-data-table>
      </t4-container>
    </mat-tab>
    }


    <mat-tab label="{{'T4.Campaigns.Campaign.tabusedcampaign' | translate : 'Rentals' }}">
      <t4-container>
        <t4-data-table #tblUsedcampaign [allowFilter]="true" apiMethod="/Campaign/GetBookingsForCampaign" [parameters]="{ parentCode: CampagneID }" headline="{{'T4.Campaigns.campaigns.lblusedpromotions' | translate : 'Used promotions' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false" [filterFields]="['Id','DiscountId']">
          <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{'T4.Campaigns.Campaign.lblrentalId' |translate : ' Rental ID' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;"><t4-booking-link bookingId="{{row.Id}}"></t4-booking-link></mat-cell>
          </ng-container>

          <ng-container matColumnDef="rentallocation">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{'T4.Campaigns.Campaign.lblPickupLacation' |translate : 'Pickup Location' }}</mat-header-cell>
            <mat-cell class="bookinginfo" *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{ row.PickupLocation?.City }}</mat-cell>
          </ng-container>



          <ng-container matColumnDef="PickupTime">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{'T4.Campaigns.Campaign.lblrentalstarttime' |translate : 'Rental start' }}</mat-header-cell>
            <mat-cell class="bookinginfo" *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{ row.PickupTime | date : 'yyyy-MM-dd'}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="endrental">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{'T4.Campaigns.Campaign.lblrentalendtime' |translate : 'Rental end' }}</mat-header-cell>
            <mat-cell class="bookinginfo" *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{ row.ReturnTime | date : 'yyyy-MM-dd'}}</mat-cell>
          </ng-container>
        </t4-data-table>
      </t4-container>
    </mat-tab>
  </mat-tab-group>
</ng-container>
}

